import Input from '../../../Components/Input';
import AddressInput from '../../../Components/InputAddress';
import InputEmail from '../../../Components/InputEmail';
import InputInsurancePicker from '../../../Components/InputInsurancePicker';
import InputPhoneNumber from '../../../Components/InputPhoneNumber';
import InputZipcode from '../../../Components/InputZipcode';

import YesNoToggle from '../../../Components/YesNoToggle';
import isSet from '../../../Helpers/isSet';
import styleStringToObj from '../../../Helpers/styleStringToObj';

const inputs = {
    zipcode: InputZipcode,
    phone: InputPhoneNumber,
    email: InputEmail,
    insurancePicker: InputInsurancePicker,
    text: Input,
    address: AddressInput,
    number: Input,
    toggle: YesNoToggle,
};

const FormInputs = ({
    show = true,
    formData = {},
    inputFields = [],
    showError = false,
    handleInputChange = () => {},
    parameterizableQuoteFields = [],
}) => {
    return (
        show && (
            <div data-testid="input-section">
                {inputFields.map(input => {
                    if (input.type === 'parameterizable') {
                        input = parameterizableQuoteFields.find(item => item.name === input.name);
                        if (!input?.render) {
                            return null;
                        }
                    }

                    const {
                        name = '',
                        label = '',
                        placeholder = '',
                        placeholderMobile = '',
                        type = '',
                        required = false,
                        requirementText,
                    } = input;
                    const inlineStyle = styleStringToObj(input.inlineStyle || '');
                    const Component = inputs[type];
                    const errorText =
                        required && !isSet(formData[name])
                            ? requirementText
                                ? requirementText
                                : 'This field is required'
                            : '';
                    return (
                        <Component
                            key={`input-${name}`}
                            type={type}
                            requirementText={requirementText}
                            label={label}
                            name={name}
                            isRequired={required}
                            externalErrorMessage={errorText}
                            showError={showError}
                            value={formData[name] || ''}
                            placeholder={placeholder}
                            placeholderMobile={placeholderMobile}
                            inlineStyle={inlineStyle}
                            onChange={(e, isValid) =>
                                handleInputChange({
                                    type,
                                    name,
                                    element: e.target,
                                    isValid,
                                })
                            }
                            pageId={window?.page_id || 0}
                            externalInsuranceTypes={formData?.cachedInputTypes || []}
                        />
                    );
                })}
            </div>
        )
    );
};

export default FormInputs;
